import type { InjectionKey, Ref } from "vue";

import type { Maybe } from "shared/types";

// ModalService mounts exactly one ModalsContainer, so this is safe as an id.
export const MODALS_CONTAINER_ID = "modals-container";

// Where to teleport a dropdown that opens inside a modal.
//
// MODAL_FOCUS_TRAP_TARGET is the modal box. Use it normally: a modal holds
// keyboard focus inside itself, so a dropdown left outside the box cannot be
// typed into — focus jumps straight back to the modal.
//
// MODALS_OVERLAY_TARGET is the wrapper around all modals. The box can cut off
// a dropdown taller than itself; this wrapper never does. Only for dropdowns
// that set `trap-focus`, because those hold focus themselves.
export const MODALS_OVERLAY_TARGET: InjectionKey<Ref<Maybe<HTMLElement>>> =
  Symbol("modalsOverlayTarget");

export const MODAL_FOCUS_TRAP_TARGET: InjectionKey<Ref<Maybe<HTMLElement>>> =
  Symbol("modalFocusTrapTarget");
